import { render, staticRenderFns } from "./ReportingManager.vue?vue&type=template&id=254a8d5a"
import script from "./ReportingManager.vue?vue&type=script&lang=js"
export * from "./ReportingManager.vue?vue&type=script&lang=js"
import style0 from "./ReportingManager.vue?vue&type=style&index=0&id=254a8d5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports